export default __webpack_public_path__ + "static/ba-781c655e73b78155ac3e2a046d38363a.png";